
export const isApiError = (error: any): boolean => {
    return error?.response !== undefined
}